import { useEffect } from 'react';
import { StandardJourneyBrandedScreen } from '~/components/StandardJourney';
import { captureEvent } from '~/analytics/posthog';
import ContractCompletedView from '../components/ContractCompletedView';
import { CONTRACT_JOURNEY_APP_IDS } from '../contractAppIds';

export default function ContractCompletedPage() {
  useEffect(() => {
    captureEvent('contract_completed');
  }, []);

  return (
    <StandardJourneyBrandedScreen
      appId={CONTRACT_JOURNEY_APP_IDS.completed}
      checkoutActiveStep={3}
      contentLayout="checkout"
      progressPercent={100}
      showBack={false}
    >
      <ContractCompletedView />
    </StandardJourneyBrandedScreen>
  );
}
